// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"268":"Home","313":"Lab","362":"Dashboard","570":"Corporate","686":"Doctor","771":"Patient"}[chunkId] || chunkId) + "." + {"85":"70046dbb","268":"4e170ae6","313":"eec3e7e5","362":"573987a0","570":"1c55df3d","686":"3fa31f2d","771":"3c83422a"}[chunkId] + ".chunk.css";
};